import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found — Nanny Poppins UAE" });
  return (
    <section className="container-page flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-serif text-4xl tracking-tight sm:text-5xl">This page can't be found.</h1>
      <p className="mt-4 max-w-md text-[#0B0A08]/70">
        The page you're looking for may have moved. Let's get you back on track.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-8 inline-flex items-center justify-center rounded-full bg-[#0B0A08] px-7 py-3.5 text-sm font-semibold text-[#F7F4ED] hover:bg-[#0B0A08]/85"
      >
        Back to home
      </Link>
    </section>
  );
}
